import React from 'react'
import { Button, Input, message } from 'antd'
import { readBookingsAggregate } from '../../Admin/bookings/utils/utils'
import { handleError } from '../../lib/utils'
import dayjs from 'dayjs'

const OtpCapture = ({ formData, setFormData, setCurrentStep, form, setPickerValue, setBookingData }) => {
  const handleOtpSubmit = async (e) => {
    if (formData.otp.length < 6) return message.error('OTP must be 6 digits')
    try {
      let bookingRecord = await readBookingsAggregate({ otp: formData.otp, status: 'check_in' })
      if (!bookingRecord.length) return message.error('Invalid OTP')
      setBookingData(bookingRecord[0])
      const patientData = bookingRecord[0].patientRecord
      setFormData({
        ...formData,
        bookingId: bookingRecord[0]._id,
        patientRecord: patientData,
        basicInfo: {
          firstName: patientData.firstName || '',
          lastName: patientData.lastName || '',
          phoneNumber: patientData.phoneNumber || '',
          email: patientData.email || '',
          physicalAddress: patientData.physicalAddress || '',
          dateOfBirth: patientData.dateOfBirth ? dayjs(patientData.dateOfBirth) : null,
          medicalAid: {
            name: patientData.medicalAid?.name || '',
            schemeCode: patientData.medicalAid?.schemeCode || '',
            plan: patientData.medicalAid?.plan || '',
            planCode: patientData.medicalAid?.planCode || '',
            planOption: patientData.medicalAid?.planOption || '',
            planOptionCode: patientData.medicalAid?.planOptionCode || '',
            number: patientData.medicalAid?.number || '',
            dependantNumber: patientData.medicalAid?.dependantNumber || ''
          }
        }
      })

      // Set form values
      form.setFieldsValue({
        firstName: patientData.firstName || '',
        lastName: patientData.lastName || '',
        phoneNumber: patientData.phoneNumber || '',
        email: patientData.email || '',
        physicalAddress: patientData.physicalAddress || '',
        dateOfBirth: patientData.dateOfBirth ? dayjs(patientData.dateOfBirth) : null,
        medicalAid: {
          name: patientData.medicalAid?.name || '',
          schemeCode: patientData.medicalAid?.schemeCode || '',
          plan: patientData.medicalAid?.plan || '',
          planCode: patientData.medicalAid?.planCode || '',
          planOption: patientData.medicalAid?.planOption || '',
          planOptionCode: patientData.medicalAid?.planOptionCode || '',
          number: patientData.medicalAid?.number || '',
          dependantNumber: patientData.medicalAid?.dependantNumber || ''
        }
      })

      // Set picker value for date of birth
      if (patientData.dateOfBirth) {
        setPickerValue(dayjs(patientData.dateOfBirth))
      }

      setCurrentStep(2)
    } catch (error) {
      message.error('Failed to verify OTP')
    }
  }

  return (
    <div className='step-container'>
      <h2>Patient Check-in</h2>
      <p>Please enter your booking OTP to continue</p>
      <form className='otp-form'>
        <div className='input-group'>
          <label htmlFor='otp'>Enter OTP</label>
          <Input
            type='text'
            id='otp'
            value={formData.otp}
            onChange={(e) => setFormData({ ...formData, otp: e.target.value })}
            placeholder='Enter 4-6 digit OTP'
            maxLength='6'
            className='otp-input'
          />
        </div>
        <Button onClick={handleOtpSubmit} className='btn-primary' disabled={formData.otp.length < 6}>
          Continue
        </Button>
      </form>
    </div>
  )
}

export default OtpCapture
